import React from 'react';

/**
 * Single-color icon drawn as a CSS mask, so its color comes from the active skin
 * (background: var(--chat-action) by default; override per usage in _chat.scss).
 * Size it with CSS on the className.
 */
export default function ChatIcon({ src, className = '' }) {
    const mask = `url("${src}")`;
    return (
        <span
            className={`chat-icon ${className}`}
            style={{ maskImage: mask, WebkitMaskImage: mask }}
            aria-hidden="true"
        />
    );
}
